import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { Media } from '@klickdata/core/media/src/media.model';
import { MediaService } from '@klickdata/core/media/src/media.service';
import { S3MediaService } from '@klickdata/core/media/src/s3-media.service';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { BehaviorSubject, forkJoin, Observable, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'app-upload-image-to-aws',
    templateUrl: './upload-image-to-aws.component.html',
    styleUrls: ['./upload-image-to-aws.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadImageToAwsComponent extends OnDestroyHandler {
    @Input() allowedMimeType: string[] = ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'];
    @Input() allowMultiple: boolean = false;
    @Input() userImg: boolean = false;
    @Input() uploadBtnLabel: string = $localize`Upload image`;
    @Input() uploadBtnTooltip: string = $localize`Upload image`;
    @Output() saving: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onMediasReady: EventEmitter<Media[]> = new EventEmitter<Media[]>();
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
    @ViewChild('contentWrapper', { read: ElementRef }) contentWrapper: ElementRef;
    public progress$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
    public hasProjectedContent: boolean = false;

    constructor(
        protected mediaService: MediaService,
        protected s3MediaService: S3MediaService,
        private cdr: ChangeDetectorRef
    ) {
        super();
    }

    public prepareFiles(event: Event) {
        const files = Array.from((event.target as HTMLInputElement).files) as File[];
        this.handleFiles(files);
    }
    ngAfterViewInit(): void {
        this.hasProjectedContent = this.contentWrapper?.nativeElement?.childNodes?.length > 0;
        this.cdr.detectChanges();
    }
    public handleFiles(files: File[]): void {
        this.saving.emit(true);
        this.uploadFiles(files)
            .pipe(takeUntil(this.destroy))
            .subscribe(
                (mediaKeys) => {
                    this.saving.emit(false);
                    this.onMediasReady.emit(mediaKeys);
                    this.progress$.next(null);
                },
                (err) => {}
            );
    }

    private uploadFiles(files: File[]): Observable<Media[]> {
        const uploadObservables = files.map((file) =>
            this.s3MediaService.uploadMediaToS3(file, this.progress$).pipe(
                takeUntil(this.destroy),
                switchMap((media) =>
                    this.mediaService.uploadMediaByLink({
                        ...media.getData(),
                    })
                ),
                takeUntil(this.destroy)
            )
        );

        return forkJoin(uploadObservables);
    }
}
